import { styled } from 'styled-components'

export const DateTimeCell = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.space['2'],
}))

export const ResidentWrapper = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.space['8'],
}))

export const ResidentNameContainer = styled.div(({ theme }) => ({
  '> span': {
    minWidth: 0,
    textWrap: 'nowrap',
  },
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'row',

  gap: theme.space['10'],
}))

export const InHouseIconWrapper = styled.span(({ theme }) => ({
  alignItems: 'center',
  background: theme.colors.green100,
  borderRadius: theme.border.radius['full'],
  cursor: 'pointer',
  display: 'flex',
  justifyContent: 'center',
  padding: `${theme.space['4']}`,
}))

export const VacationIconWrapper = styled.span(({ theme }) => ({
  alignItems: 'center',
  backgroundColor: theme.colors.red100,
  borderRadius: theme.border.radius['full'],
  cursor: 'pointer',
  display: 'flex',
  justifyContent: 'center',
  padding: `${theme.space['4']}`,
}))

export const StatusWrapper = styled.div(({ theme }) => ({
  alignItems: 'start',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.space['4'],
}))
